<div class="admin-container">
    <h3 *ngIf="!showForm">Welcome Admin ;)</h3>
    <h3 *ngIf="showForm">New Event!</h3>
    <app-new-event-input (notifyParent)="switchForm()"></app-new-event-input>
    <app-admin-future-dates-calendar *ngIf="!showForm"></app-admin-future-dates-calendar>
</div>